import { TOGGLE_SPARKED_MODE } from "./sparkedModeReducer"

export const toggleSparkedMode = (value, type) => ({
    type: TOGGLE_SPARKED_MODE,
    payload: {value: value, type: type}
})